import React from "react";
import { Typography, Collapse, Alert, Divider } from "antd";
import { useMsal, useAccount } from "@azure/msal-react";

export const UploadInformation: React.FC = () => {
  const { instance, accounts } = useMsal();

  return (
    <>
      <p>
        To progress your registration, please upload your documents so that we
        can verify your details, your right to study with us and your financial
        arrangements.
      </p>
      <p>
        The documents you provide will be held on the portal until your
        registration is complete and then transferred and stored on your student
        record in keeping with the{" "}
        <Typography.Link
          target="_blank"
          href="https://www.herts.ac.uk/__data/assets/pdf_file/0017/233090/IM08-Data-Protection.pdf"
        >
          University’s GDPR data protection policy
        </Typography.Link>
        .
      </p>
      <p>
        Check your{" "}
        <Typography.Link href="https://joining.herts.ac.uk">
          Joining Instructions
        </Typography.Link>{" "}
        for the documents you need to upload.
      </p>
    </>
  );
};
